import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'environments/environment';

import { BrowserSessionService } from '../services/browser-session.service';

const sessionHeader = 'X-OpenFLIS-Session-Id';

export const browserSessionInterceptor: HttpInterceptorFn = (request, next) => {
    if (!isOpenFlisApiRequest(request.url)) {
        return next(request);
    }

    const sessionId = inject(BrowserSessionService).getSessionId();
    return next(request.clone({
        setHeaders: {
            [sessionHeader]: sessionId
        }
    }));
};

function isOpenFlisApiRequest(url: string): boolean {
    return [environment.apiUrl, environment.searchApiUrl]
        .map(baseUrl => baseUrl.replace(/\/$/, ''))
        .some(baseUrl => url === baseUrl || url.startsWith(`${baseUrl}/`));
}
